import * as React from "react";

function Search(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.133 17.559a7.426 7.426 0 115.866-2.872l5.001 5L19.687 21l-5-5a7.393 7.393 0 01-4.554 1.559zm5.57-7.426a5.57 5.57 0 11-11.14 0 5.57 5.57 0 0111.14 0z"
      />
    </svg>
  );
}

export default Search;
